import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { key: 0 };
var _hoisted_2 = { class: "table-container" };
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("h1", null, "Gestione Consensi Trattamenti", -1);
var _hoisted_4 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
var _hoisted_5 = { class: "styled-table" };
var _hoisted_6 = /*#__PURE__*/ _createElementVNode("thead", { class: "accessColor" }, [
    /*#__PURE__*/ _createElementVNode("th"),
    /*#__PURE__*/ _createElementVNode("th", null, "Trattamento"),
    /*#__PURE__*/ _createElementVNode("th", null, "Finalità"),
    /*#__PURE__*/ _createElementVNode("th", null, "Informativa"),
    /*#__PURE__*/ _createElementVNode("th", null, "Data")
], -1);
var _hoisted_7 = { class: "grid-item" };
var _hoisted_8 = ["data-id", "disabled", "onUpdate:modelValue", "onChange"];
var _hoisted_9 = { class: "grid-item" };
var _hoisted_10 = { class: "grid-item" };
var _hoisted_11 = { class: "grid-item" };
var _hoisted_12 = { class: "grid-item" };
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Consensi',
    setup: function (__props) {
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        function updateConsent(consent) {
            //request to update consent
            consent.data_consenso = new Date();
            store.updateConsenso(consent, consent.Id_Consenso_P);
        }
        function formatDate(dateString) {
            var date = new Date(dateString);
            return date.toLocaleDateString('it-IT', { day: "numeric", month: "numeric", year: '2-digit' });
        }
        return function (_ctx, _cache) {
            return (_unref(patient))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _hoisted_4,
                        _createElementVNode("table", _hoisted_5, [
                            _hoisted_6,
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).consensi, function (consent) {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: consent.Id_Trattamento
                                    }, [
                                        _createElementVNode("td", _hoisted_7, [
                                            _withDirectives(_createElementVNode("input", {
                                                "data-id": consent.Id_Trattamento,
                                                disabled: consent.Id_Trattamento === 14,
                                                class: "toggle-class",
                                                type: "checkbox",
                                                "data-onstyle": "success",
                                                "data-offstyle": "danger",
                                                "data-toggle": "toggle",
                                                "data-on": 'Accetto',
                                                "data-off": 'Rifiuto',
                                                "onUpdate:modelValue": function ($event) { return ((consent.Consenso) = $event); },
                                                onChange: function ($event) { return (updateConsent(consent)); }
                                            }, null, 40, _hoisted_8), [
                                                [_vModelCheckbox, consent.Consenso]
                                            ])
                                        ]),
                                        _createElementVNode("td", _hoisted_9, _toDisplayString(consent.trattamento.Nome_T), 1),
                                        _createElementVNode("td", _hoisted_10, _toDisplayString(consent.trattamento.Finalita_T), 1),
                                        _createElementVNode("td", _hoisted_11, _toDisplayString(consent.trattamento.Informativa), 1),
                                        _createElementVNode("td", _hoisted_12, _toDisplayString(formatDate(consent.data_consenso)), 1)
                                    ]));
                                }), 128))
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
